<template>
    <div>
        <div v-if="type == 'icon'">
            <a
                :href="layer.infoUrl"
                target="info"
                onclick="event.stopPropagation()"
            >
                <img
                    class="theme-eye px-1"
                    src="~@/assets/imported-icons/ic_fluent_info_20_regular.svg"
                    :title="$t('infoData.show')"
                    :alt="$t('infoData.show')"
                />
            </a>
        </div>
        <div v-else-if="type == 'button'">
            <b-button :href="layer.infoUrl" target="info">
                {{ $t('infoData.showButton') }}</b-button
            >
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            layer: { type: Object, required: true },
            type: { type: String, required: false, default: 'icon' }
        }
    };
</script>

<style scoped>
.theme-eye {
    cursor: pointer;
}
</style>
